import { ref, computed } from 'vue'
import { getFromIndexedDB, saveToIndexedDB, KEYS, initSyncChannel, syncChannel } from '../services/indexedDBService.js'
import api from '../services/api.js'

// Estado reactivo compartido
const referencias = ref({ referencias: [] })
const objetos = ref({ objetos: [] })
const vinculos = ref({ vinculos: [] })
const botVinculos = ref({ sabes_algo_mas: {}, bot_vinculos: [] })
const claseVinculos = ref({ clase_vinculos: [] })
const rasgosPersonalidad = ref({ rasgos_personalidad: [] })
const rasgosGenero = ref({
  rasgos_genero: [
    { codigo: 'gen_femenino', descripcion: 'Femenino' },
    { codigo: 'gen_masculino', descripcion: 'Masculino' },
    { codigo: 'gen_indefinido', descripcion: 'Indefinido' }
  ]
});
const rasgosEdad = ref({
  rasgos_edad: [
    { codigo: 'edad_joven', descripcion: 'Joven' },
    { codigo: 'edad_maduro', descripcion: 'Maduro' },
    { codigo: 'edad_viejo', descripcion: 'Viejo' },
    { codigo: 'edad_joven_o_maduro', descripcion: 'Joven o Maduro' },
    { codigo: 'edad_maduro_o_viejo', descripcion: 'Maduro o Viejo' }
  ]
});
const rasgosFisicos = ref({ rasgos_fisicos: [] })
const rasgosClase = ref({ rasgos_clase: [] })
const rasgosEconomicos = ref({ rasgos_economicos: [] })
const claseRasgosEconomicos = ref({ clase_rasgos_economicos: [] })
const afinidades = ref({ afinidades: [] })
const ocupaciones = ref({ ocupaciones: [] })
const claseOcupaciones = ref({ clase_ocupaciones: [] })
const apellidos = ref({ apellidos: [] })
const descartesTiposMetodos = ref({ descartes_tipos_metodos: [] })
const textosConjuncionesAdversativas = ref({ textos_conjunciones_adversativas: { conjunciones_adversativas: [] } })
const textosCoincidencias = ref({ textos_coincidencias: { frases_coincidencia: [], coletillas_frases_coincidencia: [], frases_coincidencia_bot: [], coletillas_frases_coincidencia_bot: [] } })
const epilogos = ref({
  epilogos: {
    asesino: {
      hasganado: [], hasperdido: [],
      mododosjugadores: { hasganado: [], hasperdido: [] },
    },
    inocente: {
      modosolitario: { hasganado: [], hasperdido: [] },
      mododosjugadores: { hasganado: [], hasperdido: [] },
      habeisganado: { hasacertado: [], hasfallado: [] },
      habeisperdido: { hasacertado: [], hasfallado: [] }
    }
  }
})
const escenarios = ref({ escenarios: [] })
const personajes = ref({ personajes: [] })
const colecciones = ref({ colecciones: [] })
const historias = ref({ historias: [] })
const metodos = ref({ metodos: [] })
const actos = ref({
  actos: [
    { id: 0, nombre: 'Acto de Presentación' },
    { id: 1, nombre: 'Primer Acto' },
    { id: 2, nombre: 'Segundo Acto' },
    { id: 3, nombre: 'Acto Final' }
  ]
})

// Función para mostrar toast de sincronización
function showSyncToast(key) {
  const toastEl = document.getElementById('sync-toast')
  const toastBody = document.getElementById('sync-toast-body')

  if (!toastEl || !toastBody) {
    console.warn('Toast element not found')
    return
  }

  // Mapear keys a nombres amigables
  const friendlyNames = {
    [KEYS.HISTORIAS]: 'Historias',
    [KEYS.METODOS]: 'Métodos',
    [KEYS.REFERENCIAS]: 'Referencias',
    [KEYS.VINCULOS]: 'Vínculos',
    [KEYS.BOT_VINCULOS]: 'Bot Vínculos',
    [KEYS.CLASE_VINCULOS]: 'Clase Vínculos',
    [KEYS.OBJETOS]: 'Objetos',
    [KEYS.RASGOS_PERSONALIDAD]: 'Rasgos de Personalidad',
    [KEYS.RASGOS_FISICOS]: 'Rasgos Físicos',
    [KEYS.RASGOS_CLASE]: 'Rasgos de Clase',
    [KEYS.RASGOS_ECONOMICOS]: 'Rasgos Económicos',
    [KEYS.CLASE_RASGOS_ECONOMICOS]: 'Clase Rasgos Económicos',
    [KEYS.AFINIDADES]: 'Afinidades',
    [KEYS.OCUPACIONES]: 'Ocupaciones',
    [KEYS.CLASE_OCUPACIONES]: 'Clase Ocupaciones',
    [KEYS.APELLIDOS]: 'Apellidos',
    [KEYS.EPILOGOS]: 'Epílogos',
    [KEYS.ESCENARIOS]: 'Escenarios',
    [KEYS.PERSONAJES]: 'Personajes',
    [KEYS.COLECCIONES]: 'Colecciones',
    [KEYS.DESCARTES_TIPOS_METODOS]: 'Descartes Tipos Métodos',
    [KEYS.TEXTOS_CONJUNCIONES_ADVERSATIVAS]: 'Textos Conjunciones Adversativas',
    [KEYS.TEXTOS_COINCIDENCIAS]: 'Textos Coincidencias'
  }

  const friendlyName = friendlyNames[key] || key
  toastBody.innerHTML = `📥 <strong>${friendlyName}</strong> actualizado desde otra pestaña`

  // Crear instancia de toast de Bootstrap y mostrarlo
  if (typeof window !== 'undefined' && window.bootstrap) {
    const toast = new window.bootstrap.Toast(toastEl, {
      autohide: true,
      delay: 4000
    })
    toast.show()
  }
}

// Inicializar canal de sincronización
initSyncChannel()

// Listener para cambios de otras pestañas
if (syncChannel) {
  syncChannel.addEventListener('message', async (event) => {
    const { type, key } = event.data

    if (type === 'UPDATE') {
      console.log(`📥 Recibido cambio de otra pestaña: ${key}`)
      // Refrescar solo el key que cambió
      await refreshKey(key)
      // Mostrar toast de notificación
      showSyncToast(key)
    }
  })
  console.log('📡 Escuchando cambios de otras pestañas')
}


let isLoaded = false
let loadPromise = null

/**
 * Refrescar datos desde IndexedDB sin importar el estado de carga
 * Útil para sincronizar entre pestañas
 */
async function refreshFromIndexedDB() {
  console.log('🔄 Refrescando datos desde IndexedDB...')

  const refData = await getFromIndexedDB(KEYS.REFERENCIAS);
  if (refData) referencias.value = refData;
  
  const descartesData = await getFromIndexedDB(KEYS.DESCARTES_TIPOS_METODOS);
  if (descartesData) descartesTiposMetodos.value = descartesData

  const conjAdvData = await getFromIndexedDB(KEYS.TEXTOS_CONJUNCIONES_ADVERSATIVAS);
  if (conjAdvData) textosConjuncionesAdversativas.value = conjAdvData

  const coincData = await getFromIndexedDB(KEYS.TEXTOS_COINCIDENCIAS);
  if (coincData) textosCoincidencias.value = coincData

  const botVinData = await getFromIndexedDB(KEYS.BOT_VINCULOS);
  if (botVinData) botVinculos.value = botVinData

  const objData = await getFromIndexedDB(KEYS.OBJETOS);
  if (objData) objetos.value = objData

  const vinData = await getFromIndexedDB(KEYS.VINCULOS);
  if (vinData) vinculos.value = vinData
  
  const claseVinData = await getFromIndexedDB(KEYS.CLASE_VINCULOS);
  if (claseVinData) claseVinculos.value = claseVinData

  const rasgosP = await getFromIndexedDB(KEYS.RASGOS_PERSONALIDAD);
  if (rasgosP) rasgosPersonalidad.value = rasgosP

  const rasgosF = await getFromIndexedDB(KEYS.RASGOS_FISICOS);
  if (rasgosF) rasgosFisicos.value = rasgosF

  const rasgosC = await getFromIndexedDB(KEYS.RASGOS_CLASE);
  if (rasgosC) rasgosClase.value = rasgosC

  const rasgosEco = await getFromIndexedDB(KEYS.RASGOS_ECONOMICOS);
  if (rasgosEco) rasgosEconomicos.value = rasgosEco

  const claseRasgosEco = await getFromIndexedDB(KEYS.CLASE_RASGOS_ECONOMICOS);
  if (claseRasgosEco) claseRasgosEconomicos.value = claseRasgosEco

  const afin = await getFromIndexedDB(KEYS.AFINIDADES);
  if (afin) afinidades.value = afin

  const ocup = await getFromIndexedDB(KEYS.OCUPACIONES);
  if (ocup) ocupaciones.value = ocup

  const claseOcup = await getFromIndexedDB(KEYS.CLASE_OCUPACIONES);
  if (claseOcup) claseOcupaciones.value = claseOcup

  const apel = await getFromIndexedDB(KEYS.APELLIDOS);
  if (apel) apellidos.value = apel

  const epi = await getFromIndexedDB(KEYS.EPILOGOS);
  if (epi) epilogos.value = epi

  const esc = await getFromIndexedDB(KEYS.ESCENARIOS);
  if (esc) escenarios.value = esc

  const pers = await getFromIndexedDB(KEYS.PERSONAJES);
  if (pers) personajes.value = pers

  const hist = await getFromIndexedDB(KEYS.HISTORIAS);
  if (hist) historias.value = hist

  const metData = await getFromIndexedDB(KEYS.METODOS);
  if (metData) metodos.value = metData

  const colData = await getFromIndexedDB(KEYS.COLECCIONES);
  if (colData) colecciones.value = colData

  console.log('✅ Datos refrescados desde IndexedDB')
}

/**
 * Refrescar un key específico desde IndexedDB
 */
async function refreshKey(key) {
  const data = await getFromIndexedDB(key)
  if (!data) return

  switch (key) {
    case KEYS.REFERENCIAS:
      referencias.value = data
      break
    case KEYS.OBJETOS:
      objetos.value = data
      break
    case KEYS.VINCULOS:
      vinculos.value = data
      break
    case KEYS.BOT_VINCULOS:
      botVinculos.value = data
      break
    case KEYS.CLASE_VINCULOS:
      claseVinculos.value = data
      break
    case KEYS.RASGOS_PERSONALIDAD:
      rasgosPersonalidad.value = data
      break
    case KEYS.RASGOS_FISICOS:
      rasgosFisicos.value = data
      break
    case KEYS.RASGOS_CLASE:
      rasgosClase.value = data
      break
    case KEYS.RASGOS_ECONOMICOS:
      rasgosEconomicos.value = data
      break
    case KEYS.CLASE_RASGOS_ECONOMICOS:
      claseRasgosEconomicos.value = data
      break
    case KEYS.AFINIDADES:
      afinidades.value = data
      break
    case KEYS.OCUPACIONES:
      ocupaciones.value = data
      break
    case KEYS.CLASE_OCUPACIONES:
      claseOcupaciones.value = data
      break
    case KEYS.APELLIDOS:
      apellidos.value = data
      break
    case KEYS.EPILOGOS:
      epilogos.value = data
      break
    case KEYS.ESCENARIOS:
      escenarios.value = data
      break
    case KEYS.PERSONAJES:
      personajes.value = data
      break
    case KEYS.HISTORIAS:
      historias.value = data
      break
    case KEYS.METODOS:
      metodos.value = data
      break
    case KEYS.DESCARTES_TIPOS_METODOS:
      descartesTiposMetodos.value = data
      break
    case KEYS.TEXTOS_CONJUNCIONES_ADVERSATIVAS:
      textosConjuncionesAdversativas.value = data
      break
    case KEYS.TEXTOS_COINCIDENCIAS:
      textosCoincidencias.value = data
      break
    case KEYS.COLECCIONES:
      colecciones.value = data
      break
  }

  console.log(`✅ Key ${key} refrescado desde IndexedDB`)
}

// Cargar datos iniciales desde el servidor
async function loadAllGameData() {
  if (isLoaded) return Promise.resolve()
    if (loadPromise) return loadPromise
  
  loadPromise = (async () => {
    try {
      // Intentar cargar desde IndexedDB primero
      const refData = await getFromIndexedDB(KEYS.REFERENCIAS)
      if (!refData) {
        const refServerData = await api.loadAsset('referencias.json')
        await saveToIndexedDB(KEYS.REFERENCIAS, refServerData)
        referencias.value = refServerData
      } else {        
        referencias.value = refData
      }
      
      const objData = await getFromIndexedDB(KEYS.OBJETOS)
      if (!objData) {
        const objServerData = await api.loadAsset('objetos.json')
        await saveToIndexedDB(KEYS.OBJETOS, objServerData)
        objetos.value = objServerData
      } else {
        objetos.value = objData
      }

      const vinData = await getFromIndexedDB(KEYS.VINCULOS)
      if (!vinData) {
        const vinServerData = await api.loadAsset('vinculos.json')
        await saveToIndexedDB(KEYS.VINCULOS, vinServerData)
        vinculos.value = vinServerData
      } else {
        vinculos.value = vinData
      }

      const botVinData = await getFromIndexedDB(KEYS.BOT_VINCULOS)
      if (!botVinData) {
        const botVinServerData = await api.loadAsset('bot_vinculos.json')
        await saveToIndexedDB(KEYS.BOT_VINCULOS, botVinServerData)
        botVinculos.value = botVinServerData
      } else {
        botVinculos.value = botVinData
      }
      
      const claseVinData = await getFromIndexedDB(KEYS.CLASE_VINCULOS)
      if (!claseVinData) {
        const claseVinServerData = await api.loadAsset('clase_vinculos.json')
        await saveToIndexedDB(KEYS.CLASE_VINCULOS, claseVinServerData)
        claseVinculos.value = claseVinServerData
      } else {
        claseVinculos.value = claseVinData
      }

      const rasgosP = await getFromIndexedDB(KEYS.RASGOS_PERSONALIDAD)
      if (!rasgosP) {
        const serverData = await api.loadAsset('rasgos_personalidad.json')
        await saveToIndexedDB(KEYS.RASGOS_PERSONALIDAD, serverData)
        rasgosPersonalidad.value = serverData
      } else {
        rasgosPersonalidad.value = rasgosP
      }

      const rasgosF = await getFromIndexedDB(KEYS.RASGOS_FISICOS)
      if (!rasgosF) {
        const serverData = await api.loadAsset('rasgos_fisicos.json')
        await saveToIndexedDB(KEYS.RASGOS_FISICOS, serverData)
        rasgosFisicos.value = serverData
      } else {
        rasgosFisicos.value = rasgosF
      }

      const rasgosC = await getFromIndexedDB(KEYS.RASGOS_CLASE)
      if (!rasgosC) {
        const serverData = await api.loadAsset('rasgos_clase.json')
        await saveToIndexedDB(KEYS.RASGOS_CLASE, serverData)
        rasgosClase.value = serverData
      } else {
        rasgosClase.value = rasgosC
      }

      const rasgosEco = await getFromIndexedDB(KEYS.RASGOS_ECONOMICOS)
      if (!rasgosEco) {
        const serverData = await api.loadAsset('rasgos_economicos.json')
        await saveToIndexedDB(KEYS.RASGOS_ECONOMICOS, serverData)
        rasgosEconomicos.value = serverData
      } else {
        rasgosEconomicos.value = rasgosEco
      }

      const claseRasgosEco = await getFromIndexedDB(KEYS.CLASE_RASGOS_ECONOMICOS)
      if (!claseRasgosEco) {
        const serverData = await api.loadAsset('clase_rasgos_economicos.json')
        await saveToIndexedDB(KEYS.CLASE_RASGOS_ECONOMICOS, serverData)
        claseRasgosEconomicos.value = serverData
      } else {
        claseRasgosEconomicos.value = claseRasgosEco
      }

      const afin = await getFromIndexedDB(KEYS.AFINIDADES)
      if (!afin) {
        const serverData = await api.loadAsset('afinidades.json')
        await saveToIndexedDB(KEYS.AFINIDADES, serverData)
        afinidades.value = serverData
      } else {
        afinidades.value = afin
      }

      const ocup = await getFromIndexedDB(KEYS.OCUPACIONES)
      if (!ocup) {
        const serverData = await api.loadAsset('ocupaciones.json')
        await saveToIndexedDB(KEYS.OCUPACIONES, serverData)
        ocupaciones.value = serverData
      } else {
        ocupaciones.value = ocup
      }

      const claseOcup = await getFromIndexedDB(KEYS.CLASE_OCUPACIONES)
      if (!claseOcup) {
        const serverData = await api.loadAsset('clase_ocupaciones.json')
        await saveToIndexedDB(KEYS.CLASE_OCUPACIONES, serverData)
        claseOcupaciones.value = serverData
      } else {
        claseOcupaciones.value = claseOcup
      }

      const apel = await getFromIndexedDB(KEYS.APELLIDOS)
      if (!apel) {
        const serverData = await api.loadAsset('apellidos.json')
        await saveToIndexedDB(KEYS.APELLIDOS, serverData)
        apellidos.value = serverData
      } else {
        apellidos.value = apel
      }

      const epi = await getFromIndexedDB(KEYS.EPILOGOS)
      if (!epi) {
        const serverData = await api.loadAsset('epilogos.json')
        await saveToIndexedDB(KEYS.EPILOGOS, serverData)
        epilogos.value = serverData
      } else {
        epilogos.value = epi
      }

      const esc = await getFromIndexedDB(KEYS.ESCENARIOS)
      if (!esc) {
        const serverData = await api.loadAsset('escenarios.json')
        await saveToIndexedDB(KEYS.ESCENARIOS, serverData)
        escenarios.value = serverData
      } else {
        escenarios.value = esc
      }

      const pers = await getFromIndexedDB(KEYS.PERSONAJES)
      if (!pers) {
        const serverData = await api.loadAsset('personajes.json')
        await saveToIndexedDB(KEYS.PERSONAJES, serverData)
        personajes.value = serverData
      } else {
        personajes.value = pers
      }

      const hist = await getFromIndexedDB(KEYS.HISTORIAS)
      if (!hist) {
        const serverData = await api.loadAsset('historias.json')
        await saveToIndexedDB(KEYS.HISTORIAS, serverData)
        historias.value = serverData
      } else {
        historias.value = hist
      }

      const metData = await getFromIndexedDB(KEYS.METODOS)
      if (!metData) {
        const serverData = await api.loadAsset('metodos.json')
        await saveToIndexedDB(KEYS.METODOS, serverData)
        metodos.value = serverData
      } else {
        metodos.value = metData
      }

      const colData = await getFromIndexedDB(KEYS.COLECCIONES)
      if (!colData) {
        const serverData = await api.loadAsset('colecciones.json')
        await saveToIndexedDB(KEYS.COLECCIONES, serverData)
        colecciones.value = serverData
      } else {
        colecciones.value = colData
      }

      const descartesData = await getFromIndexedDB(KEYS.DESCARTES_TIPOS_METODOS)
      if (!descartesData) {
        const descartesServerData = await api.loadAsset('descartes_tipos_metodos.json')
        await saveToIndexedDB(KEYS.DESCARTES_TIPOS_METODOS, descartesServerData)
        descartesTiposMetodos.value = descartesServerData
      } else {
        descartesTiposMetodos.value = descartesData
      }

      const conjAdvData = await getFromIndexedDB(KEYS.TEXTOS_CONJUNCIONES_ADVERSATIVAS)
      if (!conjAdvData) {
        const conjAdvServerData = await api.loadAsset('textos_conjunciones_adversativas.json')
        await saveToIndexedDB(KEYS.TEXTOS_CONJUNCIONES_ADVERSATIVAS, conjAdvServerData)
        textosConjuncionesAdversativas.value = conjAdvServerData
      } else {
        textosConjuncionesAdversativas.value = conjAdvData
      }

      const coincData = await getFromIndexedDB(KEYS.TEXTOS_COINCIDENCIAS)
      if (!coincData) {
        const coincServerData = await api.loadAsset('textos_coincidencias.json')
        await saveToIndexedDB(KEYS.TEXTOS_COINCIDENCIAS, coincServerData)
        textosCoincidencias.value = coincServerData
      } else {
        textosCoincidencias.value = coincData
      }

      isLoaded = true
      console.log('Game data loaded')
    } catch (error) {
      console.error('Error loading game data:', error)
    }
  })()

  return loadPromise
}

// Composable para Referencias
export function useReferencias() {
  return {
    referencias,
    referenciasArray: computed(() => referencias.value.referencias || []),
    async updateReferencias(newData) {
      referencias.value = newData
      await saveToIndexedDB(KEYS.REFERENCIAS, newData)
    }
  }
}

// Composable para Objetos
export function useObjetos() {
  return {
    objetos,
    objetosArray: computed(() => objetos.value.objetos || []),
    async updateObjetos(newData) {
      objetos.value = newData
      await saveToIndexedDB(KEYS.OBJETOS, newData)
    }
  }
}

// Composable para Vínculos
export function useVinculos() {
  return {
    vinculos,
    vinculosArray: computed(() => vinculos.value.vinculos || []),
    async updateVinculos(newData) {
      vinculos.value = newData
      await saveToIndexedDB(KEYS.VINCULOS, newData)
    }
  }
}

// Composable para Bot Vínculos
export function useBotVinculos() {
  return {
    botVinculos,
    async updateBotVinculos(newData) {
      botVinculos.value = newData
      await saveToIndexedDB(KEYS.BOT_VINCULOS, newData)
    }
  }
}

// Composable para Rasgos de Personalidad
export function useRasgosPersonalidad() {
  return {
    rasgosPersonalidad,
    async updateRasgosPersonalidad(newData) {
      rasgosPersonalidad.value = newData
      await saveToIndexedDB(KEYS.RASGOS_PERSONALIDAD, newData)
    }
  }
}

// Composable para Rasgos de Género
export function useRasgosGenero() {
  return {
    rasgosGenero,
    async updateRasgosGenero(newData) {
      rasgosGenero.value = newData
      await saveToIndexedDB(KEYS.RASGOS_GENERO, newData)
    }
  }
}

// Composable para Rasgos de Edad
export function useRasgosEdad() {
  return {
    rasgosEdad,
    async updateRasgosEdad(newData) {
      rasgosEdad.value = newData
      await saveToIndexedDB(KEYS.RASGOS_EDAD, newData)
    }
  }
}

// Composable para Rasgos Físicos
export function useRasgosFisicos() {
  return {
    rasgosFisicos,
    async updateRasgosFisicos(newData) {
      rasgosFisicos.value = newData
      await saveToIndexedDB(KEYS.RASGOS_FISICOS, newData)
    }
  }
}

// Composable para Rasgos de Clase
export function useRasgosClase() {
  return {
    rasgosClase,
    async updateRasgosClase(newData) {
      rasgosClase.value = newData
      await saveToIndexedDB(KEYS.RASGOS_CLASE, newData)
    }
  }
}

// Composable para Rasgos Económicos
export function useRasgosEconomicos() {
  return {
    rasgosEconomicos,
    async updateRasgosEconomicos(newData) {
      rasgosEconomicos.value = newData
      await saveToIndexedDB(KEYS.RASGOS_ECONOMICOS, rasgosEconomicos.value)
    }
  }
}

// Composable para Clase Rasgos Económicos
export function useClaseRasgosEconomicos() {
  return {
    claseRasgosEconomicos,
    async updateClaseRasgosEconomicos(newData) {
      claseRasgosEconomicos.value = newData
      await saveToIndexedDB(KEYS.CLASE_RASGOS_ECONOMICOS, claseRasgosEconomicos.value)
    }
  }
}

// Composable para Clase Vínculos
export function useClaseVinculos() {
  return {
    claseVinculos,
    async updateClaseVinculos(newData) {
      claseVinculos.value = newData
      await saveToIndexedDB(KEYS.CLASE_VINCULOS, claseVinculos.value)
    }
  }
}

// Composable para Afinidades
export function useAfinidades() {
  return {
    afinidades,
    async updateAfinidades(newData) {
      afinidades.value = newData
      await saveToIndexedDB(KEYS.AFINIDADES, afinidades.value)
    }
  }
}

// Composable para Ocupaciones
export function useOcupaciones() {
  return {
    ocupaciones,
    async updateOcupaciones(newData) {
      ocupaciones.value = newData
      await saveToIndexedDB(KEYS.OCUPACIONES, newData)
    }
  }
}

// Composable para Clase Ocupaciones
export function useClaseOcupaciones() {
  return {
    claseOcupaciones,
    async updateClaseOcupaciones(newData) {
      claseOcupaciones.value = newData
      await saveToIndexedDB(KEYS.CLASE_OCUPACIONES, claseOcupaciones.value)
    }
  }
}

// Composable para Apellidos
export function useApellidos() {
  return {
    apellidos: computed(() => apellidos.value),
    async updateApellidos(newData) {
      apellidos.value = newData
      await saveToIndexedDB(KEYS.APELLIDOS, newData)
    }
  }
}

// Composable para Epílogos
export function useEpilogos() {
  return {
    epilogos: computed(() => epilogos.value),
    async updateEpilogos(newData) {
      epilogos.value = newData
      await saveToIndexedDB(KEYS.EPILOGOS, newData)
    }
  }
}

// Composable para Personajes
export function usePersonajes() {
  return {
    personajes: computed(() => personajes.value),
    async updatePersonajes(newData) {
      personajes.value = newData
      await saveToIndexedDB(KEYS.PERSONAJES, newData)
    }
  }
}

// Composable para Colecciones
export function useColecciones() {
  return {
    colecciones: computed(() => colecciones.value),
    coleccionesArray: computed(() => colecciones.value.colecciones || []),
    async updateColecciones(newData) {
      colecciones.value = newData
      await saveToIndexedDB(KEYS.COLECCIONES, newData)
    }
  }
}

// Composable para Historias
export function useHistorias() {
  return {
    historias: computed(() => historias.value),
    historiasArray: computed(() => historias.value.historias || []),
    getHistoriaById: (id) => {
      const histId = parseInt(id)
      return historias.value.historias?.find(h => h.id === histId) || null
    },
    async updateHistorias(newData) {
      historias.value = newData
      await saveToIndexedDB(KEYS.HISTORIAS, newData)
    },
    async addHistoria(historia) {
      if (!historias.value.historias) {
        historias.value.historias = []
      }
      historias.value.historias.push(historia)
      await saveToIndexedDB(KEYS.HISTORIAS, historias.value)
    },
    async deleteHistoria(historiaId) {
      const histId = parseInt(historiaId)
      historias.value.historias = historias.value.historias.filter(h => h.id !== histId)
      await saveToIndexedDB(KEYS.HISTORIAS, historias.value)
    }
  }
}

// Composable para Escenarios
export function useEscenarios() {
  return {
    escenarios: computed(() => escenarios.value),
    escenariosArray: computed(() => escenarios.value.escenarios || []),
    getEscenarioById: (id) => {
      const escId = parseInt(id)
      return escenarios.value.escenarios?.find(e => e.id === escId) || null
    },
    async updateEscenarios(newData) {
      escenarios.value = newData
      await saveToIndexedDB(KEYS.ESCENARIOS, newData)
    },
    async addEscenario(escenario) {
      if (!escenarios.value.escenarios) {
        escenarios.value.escenarios = []
      }
      escenarios.value.escenarios.push(escenario)
      await saveToIndexedDB(KEYS.ESCENARIOS, escenarios.value)
    },
    async deleteEscenario(escenarioId) {
      const escId = parseInt(escenarioId)
      escenarios.value.escenarios = escenarios.value.escenarios.filter(e => e.id !== escId)
      await saveToIndexedDB(KEYS.ESCENARIOS, escenarios.value)
    }
  }
}
export function useTrama(historiaId, tramaId) {
  console.log('=== useTrama llamado ===', historiaId, tramaId)

  // Convertir a números para comparación
  const histIdNum = parseInt(historiaId)
  const tramaIdNum = parseInt(tramaId)

  // Devolver función getter en lugar de computed para evitar recalculos constantes
  const getTrama = () => {
    console.log('getTrama ejecutado')
    const historia = historias.value.historias?.find(h => h.id === histIdNum)
    return historia?.tramas?.find(t => t.id === tramaIdNum) || null
  }

  const trama = computed(getTrama)

  async function updateTrama(updatedTrama) {
    console.log('updateTrama llamado')
    const historia = historias.value.historias?.find(h => h.id === histIdNum)
    if (!historia) return

    const tramaIndex = historia.tramas?.findIndex(t => t.id === tramaIdNum)
    if (tramaIndex === -1 || tramaIndex === undefined) return

    historia.tramas[tramaIndex] = updatedTrama
    await saveToIndexedDB(KEYS.HISTORIAS, historias.value)
  }

  return {
    trama,
    updateTrama
  }
}

// Composable para Métodos
export function useMetodos() {
  return {
    metodos: computed(() => metodos.value),
    metodosArray: computed(() => metodos.value.metodos || []),
    getMetodoById: (id) => {
      const metId = parseInt(id)
      return metodos.value.metodos?.find(m => m.id === metId) || null
    },
    async updateMetodos(newData) {
      metodos.value = newData
      await saveToIndexedDB(KEYS.METODOS, newData)
    },
    async addMetodo(metodo) {
      if (!metodos.value.metodos) {
        metodos.value.metodos = []
      }
      metodos.value.metodos.push(metodo)
      await saveToIndexedDB(KEYS.METODOS, metodos.value)
    },
    async deleteMetodo(metodoId) {
      const metId = parseInt(metodoId)
      metodos.value.metodos = metodos.value.metodos.filter(m => m.id !== metId)
      await saveToIndexedDB(KEYS.METODOS, metodos.value)
    }
  }
}

export function useActos() {
  return {
    actos: computed(() => actos.value),
    actosArray: computed(() => actos.value.actos || []),
    getActoById: (id) => {
      const actoId = parseInt(id)
      return actos.value.actos?.find(a => a.id === actoId) || null
    },
    getActoNombreById: (id) => {
      const actoId = parseInt(id)
      const acto = actos.value.actos?.find(a => a.id === actoId)
      return acto ? acto.nombre : null
    }
  }
}

// Composable para acceder a todos los datos de juego
export function useGameData() {
  return {
    referencias: computed(() => referencias.value),
    objetos: computed(() => objetos.value),
    claseVinculos: computed(() => claseVinculos.value),
    vinculos: computed(() => vinculos.value),
    botVinculos: computed(() => botVinculos.value),
    rasgosPersonalidad: computed(() => rasgosPersonalidad.value),
    rasgosFisicos: computed(() => rasgosFisicos.value),
    rasgosClase: computed(() => rasgosClase.value),
    rasgosEconomicos: computed(() => rasgosEconomicos.value),
    claseRasgosEconomicos: computed(() => claseRasgosEconomicos.value),
    afinidades: computed(() => afinidades.value),
    ocupaciones: computed(() => ocupaciones.value),
    claseOcupaciones: computed(() => claseOcupaciones.value),
    apellidos: computed(() => apellidos.value),
    epilogos: computed(() => epilogos.value),
    escenarios: computed(() => escenarios.value),
    personajes: computed(() => personajes.value),
    historias: computed(() => historias.value),
    metodos: computed(() => metodos.value),
    actos: computed(() => actos.value),
    loadAllGameData,
    refreshFromIndexedDB,
    refreshKey
  }
}

// Composable para Descartes Tipos Métodos
export function useDescartesTiposMetodos() {
  return {
    descartesTiposMetodos,
    descartesArray: computed(() => descartesTiposMetodos.value.descartes_tipos_metodos || []),
    async updateDescartesTiposMetodos(newData) {
      descartesTiposMetodos.value = newData
      await saveToIndexedDB(KEYS.DESCARTES_TIPOS_METODOS, newData)
    }
  }
}

// Composable para Textos Coincidencias
export function useTextosCoincidencias() {
  return {
    textosCoincidencias,
    async updateTextosCoincidencias(newData) {
      textosCoincidencias.value = newData
      await saveToIndexedDB(KEYS.TEXTOS_COINCIDENCIAS, newData)
    }
  }
}

// Composable para Textos Conjunciones Adversativas
export function useTextosConjuncionesAdversativas() {
  return {
    textosConjuncionesAdversativas,
    conjuncionesArray: computed(() => textosConjuncionesAdversativas.value?.textos_conjunciones_adversativas?.conjunciones_adversativas || []),
    async updateTextosConjuncionesAdversativas(newData) {
      textosConjuncionesAdversativas.value = newData
      await saveToIndexedDB(KEYS.TEXTOS_CONJUNCIONES_ADVERSATIVAS, newData)
    }
  }
}